// extracted by mini-css-extract-plugin
export var centerText = "_gq-8";
export var container = "_gq-0";
export var doughnutContainer = "_gq-7";
export var legend = "_gq-a";
export var legendItemColorDisplay = "_gq-b";
export var legendItemLabel = "_gq-d";
export var legendItemValue = "_gq-c";
export var lg = "_gq-5";
export var maxWidth = "_gq-9";
export var md = "_gq-4";
export var responsive = "_gq-6";
export var sm = "_gq-3";
export var xs = "_gq-2";
export var xxs = "_gq-1";